<div class="access-denied">
  <!-- <img src="../../../assets/img/404-error.png" alt="Access Denied" /> -->
  <h2>Access Denied</h2>
  <p>You do not have permission to access this page.</p>

  <!-- <button (click)="goHome()">Go to Dashboard</button> -->
</div>